var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-column wh-100"},[_c('div',{staticClass:"nav-menu"},[_c('navbar',{attrs:{"menuList":_vm.navMenu}})],1),_c('div',{staticClass:"router-view-content"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }